goog.provide("shadow.js.shim.module$react_virtualized_auto_sizer$default");
shadow.js.shim.module$react_virtualized_auto_sizer$default = shadow.js.require(199, {})["default"];
